import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CreateAdminComponent } from "./create-admin.component";
import { PermissionsGuardService } from "src/app/shared/services/permissions-guard.service";

const routes: Routes = [
  { path: 'create', component: CreateAdminComponent ,
    canActivate: [PermissionsGuardService]
  },
  { path: 'edit/:id', component: CreateAdminComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule {}
